module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/battle-stack.f5e5caa1.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/battle-stack.png
// module id = 3423
// module chunks = 11